import React from 'react'
import { Link } from 'gatsby'
import FrontBook from '../../static/books/dorishowe1.png'
import FrontBook1 from '../../static/books/dorishowe2.png'
const MidBook = (props) => {
    return (
        <>
            <section className="upper-main">
            <span className="italic-tag">
                                Read, and learn in various formats
                            </span>

                            <h1 className="heading--featured">
                                <span>Featured Books</span>
                                {/* <span>Books</span> */}
                            </h1>
                            <hr/>

                <div className="container-gt separator-line">

                    <div className="grid-two-columns" id="wrapper-two-books">

                            <div className="book-wraps">
                                <img src={FrontBook} alt="book-img"/>
                            </div>

                        <div className="content-wraps">

                           
                            <p>
                            Adoption Joys: They Expected a Miracle gives God's plan for unplanned pregnancies as it shares encouraging true stories of the joys adoptive couples have found in adoption.
                            </p>

                            <button className="btn-book-featured">
                                <Link to="/about-the-book">
                                    Read More
                                </Link>
                            </button>
                        

                        </div>

                        
                    </div>

                    <div className="grid-two-columns" id="wrapper-two-books">

                            

                        <div className="content-wraps-2">

                           
                            <p>
                            Doris Howe is a missionary with Youth with A Mission. Her mission field is in Tyler, Texas at Loving Alternative Adoption Agency. She has been an adoption caseworker for over 24 years.
                            </p>

                            <button className="btn-book-featured">
                                <Link to="/about-the-book">
                                    Read More
                                </Link>
                            </button>
                        

                        </div>

                        <div className="book-wraps">
                                <img src={FrontBook1} alt="book-img"/>
                            </div>

                        
                    </div>
                </div>
            </section>
        </>
    )
}

export default MidBook